var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_15626_47602)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8105 1.64597C13.073 1.58007 12.1717 1.58007 11.0316 1.58008H10.967C9.82684 1.58007 8.92562 1.58007 8.1881 1.64597C7.43051 1.71366 6.79686 1.85395 6.19799 2.16117C6.04286 2.24075 5.89177 2.32798 5.74529 2.42254C5.17979 2.78756 4.74147 3.26618 4.30406 3.88842C3.87822 4.49418 3.42761 5.27467 2.85754 6.26208L2.82525 6.318C2.25517 7.30541 1.80455 8.08589 1.49286 8.75755C1.17269 9.44749 0.97736 10.0664 0.943984 10.7386C0.935339 10.9128 0.935339 11.0872 0.943984 11.2614C0.97736 11.9336 1.17269 12.5525 1.49286 13.2425C1.80455 13.9141 2.25516 14.6946 2.82524 15.682L2.85755 15.7379C3.42761 16.7253 3.87823 17.5058 4.30406 18.1116C4.74147 18.7338 5.17979 19.2124 5.74529 19.5775C5.89177 19.672 6.04286 19.7593 6.19799 19.8388C6.79686 20.1461 7.43051 20.2863 8.1881 20.354C8.92561 20.4199 9.82682 20.4199 10.967 20.4199H11.0316C12.1717 20.4199 13.073 20.4199 13.8105 20.354C14.5681 20.2863 15.2017 20.1461 15.8006 19.8388C15.9557 19.7593 16.1068 19.672 16.2533 19.5775C16.8188 19.2124 17.2571 18.7338 17.6945 18.1116C18.1204 17.5058 18.571 16.7253 19.141 15.738L19.1733 15.682C19.7434 14.6946 20.194 13.9141 20.5057 13.2425C20.8259 12.5525 21.0212 11.9336 21.0546 11.2614C21.0632 11.0872 21.0632 10.9128 21.0546 10.7386C21.0212 10.0664 20.8259 9.44748 20.5057 8.75755C20.194 8.08588 19.7434 7.30539 19.1733 6.31798L19.1411 6.2621C18.571 5.27468 18.1204 4.49419 17.6945 3.88842C17.2571 3.26618 16.8188 2.78756 16.2533 2.42254C16.1068 2.32798 15.9557 2.24075 15.8006 2.16117C15.2017 1.85395 14.5681 1.71366 13.8105 1.64597Z",
    fill: "#47B347"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3234 8.47958C16.5767 8.1967 16.5527 7.76206 16.2698 7.50879C15.9869 7.25552 15.5523 7.27954 15.299 7.56242L12.2106 11.012C11.5848 11.711 11.1633 12.1793 10.803 12.4821C10.4598 12.7706 10.2582 12.8335 10.082 12.8335C9.90592 12.8335 9.70431 12.7706 9.36106 12.4821C9.00074 12.1793 8.57929 11.711 7.95349 11.012L7.15675 10.1221C6.90348 9.8392 6.46884 9.81519 6.18596 10.0685C5.90307 10.3217 5.87906 10.7564 6.13233 11.0392L6.96311 11.9672C7.54596 12.6182 8.03214 13.1613 8.47636 13.5347C8.94628 13.9297 9.45314 14.2085 10.082 14.2085C10.7109 14.2085 11.2178 13.9297 11.6877 13.5347C12.1319 13.1613 12.6181 12.6183 13.201 11.9672L16.3234 8.47958Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_15626_47602",
    x: -23.0625,
    y: -22.4199,
    width: 68.125,
    height: 66.8398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_15626_47602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_15626_47602",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseSuccess);
export default __webpack_public_path__ + "static/media/exercise-success.c2837fd83b24d64ea4c21cf7c55479a1.svg";
export { ForwardRef as ReactComponent };